module.exports = __webpack_public_path__ + "static/media/arrow-left.b369a94e.svg";